import React, { useState, useEffect } from "react";
import marked from "marked";
import { getBreathworkPage } from "../../contentful";
import PageTitle from "../../components/PageTitle/PageTitle";
import CourseSignup from "../../components/CourseSignup/CourseSignup";

const Breathwork = () => {
  const [content, setContent] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    getBreathworkPage().then((data) => setContent(data[0].fields));
  }, []);
  return (
    <>
      <PageTitle title='Breathwork' />
      <div className='page-content biog-page'>
        {content.image && (
          <div className='biog-page__image'>
            <img src={content.image.fields.file.url} />
          </div>
        )}
        {content.text && (
          <section className='biog-page__text' dangerouslySetInnerHTML={{ __html: marked(content.text) }} />
        )}
        {/* <CourseSignup /> */}
      </div>
    </>
  );
};

export default Breathwork;
